import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader, Button } from "reactstrap";

// código da função exibido/copiado para uso na tela a ser embedada
const GO_BACK_FUNCTION = `function goBack() {
  const payload = {
    message: "back_to"
  };
  if (
    window.ReactNativeWebView &&
    typeof window.ReactNativeWebView.postMessage === "function"
  ) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify(payload)
    );
    return;
  }
  window.history.back();
}`;

// ícone clicável que abre um modal com a função goBack() usada na tela embedada
function ModalGoBackFunction() {
  // state do modal
  const [isOpen, setIsOpen] = useState(false);
  // feedback do botão copiar
  const [copied, setCopied] = useState(false);

  // abre/fecha o modal
  function toggle() {
    setIsOpen(!isOpen);
    setCopied(false);
  }

  // copia o código da função para a área de transferência
  function copyFunction() {
    navigator.clipboard.writeText(GO_BACK_FUNCTION).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <>
      <i
        className="bx bx-code-block"
        style={{ cursor: "pointer", verticalAlign: "middle" }}
        onClick={toggle}
      />

      <Modal isOpen={isOpen} toggle={toggle} centered={true}>
        <ModalHeader toggle={toggle}>Função goBack()</ModalHeader>
        <ModalBody>
          <pre
            style={{
              backgroundColor: "#f5f5f5",
              padding: 15,
              borderRadius: 4,
              overflowX: "auto",
              fontSize: 13,
            }}
          >
            {GO_BACK_FUNCTION}
          </pre>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button color="primary" onClick={copyFunction}>
              <i className="bx bx-copy" style={{ marginRight: 5 }} />
              {copied ? "Copiado!" : "Copiar"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default ModalGoBackFunction;
